import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.af{gap:0.5rem;}.ssr-plugin'
import '.al{cursor:pointer;}.ssr-plugin'
import '.cx{padding:0.75rem;}.ssr-plugin'
import '.a8{border-radius:1.25rem;}.ssr-plugin'
import '.ag{border:var(--blue-border);}.ssr-plugin'
import '.a9{background-color:var(--shades-white);}.ssr-plugin'
import '.ck{transition:background-color 0.2s ease;}.ssr-plugin'
import '.dd{width:2.5rem;}.ssr-plugin'
import '.de{height:2.5rem;}.ssr-plugin'
import '.h4{color:var(--shades-blue-700);}.ssr-plugin'
import '.h5{font-size:0.9rem;}.ssr-plugin'
import '.aw{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a b e f af al cx a8 ag a9 ck"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="dd de a f b h4"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="h5 h4 aw"
        >
          {label}
        </span>
      </styled.button>
    )
}